var React = require('react');

function Back (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_65","d":"M0,0H10L9.832,9.885","transform":"translate(8.485 15.487) rotate(-135)","fill":"none","stroke":"#502314","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2"}));
}

Back.defaultProps = {"width":"16.901","height":"16.901","viewBox":"0 0 16.901 16.901"};

module.exports = Back;

Back.default = Back;
